import { LanguageInterface } from '@ui-kit';

export const languages: LanguageInterface[] = [
  {
    code: 'en',
    name: 'English',
  },
  {
    code: 'fr',
    name: 'French',
  },
  {
    code: 'es',
    name: 'Spanish',
  },
];
